export default __webpack_public_path__ + "static/media/alexander3big.3598761f.jpg";